import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }

import { computed, getCurrentInstance } from 'vue';
import { Placeholder, Field, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import Login from '@/components/Login/Login.vue';
import PaymentSecurityFooter from '@/components/PaymentSecurityFooter/PaymentSecurityFooter.vue';
import { useAccountStore } from '@/store';
import { IPaymentSecurityFooterData } from '@/interfaces/forms/payment-security-footer.interface';
import { normalisePaymentOptions } from '@/utils/payment-security-footer';
import NotFound from './NotFound.vue';
import MetaData from './components/MetaData/MetaData.vue';
import FullScreenSpinner from '@/components/FullScreenSpinner/FullScreenSpinner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    route: {}
  },
  setup(__props: any) {

const app = getCurrentInstance();
const contentEditing = app?.appContext?.config?.globalProperties?.$jss?.sitecoreContext()?.pageEditing === true;

const props = __props;

const accountStore = contentEditing ? { loginVisible: false } : useAccountStore();
const performLogin = computed(() => !contentEditing && (props.route.fields?.AuthenticationRequired as Field)?.value);
const pageTitle = computed(
  () => (props.route.fields?.pageTitle as Field)?.value || (props.route.fields?.Title as Field)?.value || ''
);

const globalAlerts = computed(() => {
  const globalAlertsField = props.route.fields?.GlobalAlerts as any;
  return globalAlertsField?.fields?.globalAlerts;
});

const paymentOptions = computed(() => normalisePaymentOptions(props.route.fields as IPaymentSecurityFooterData));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MetaData, { route: _ctx.route }, null, 8, ["route"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Placeholder), {
        name: "jss-header",
        pageTitle: pageTitle.value,
        rendering: _ctx.route,
        globalAlerts: globalAlerts.value
      }, null, 8, ["pageTitle", "rendering", "globalAlerts"]),
      _createElementVNode("div", {
        class: _normalizeClass(["min-h-[calc(100svh-56px-376px)] md:min-h-[calc(100svh-68px-376px)]", contentEditing ? 'lg:min-h-[200px]' : 'lg:min-h-[calc(100svh-69px-199px)]'])
      }, [
        (performLogin.value)
          ? (_openBlock(), _createBlock(Login, { key: 0 }))
          : _createCommentVNode("", true),
        (!_unref(accountStore).loginVisible)
          ? (_openBlock(), _createBlock(_unref(Placeholder), {
              key: 1,
              name: "headless-main",
              rendering: _ctx.route,
              errorComponent: NotFound
            }, null, 8, ["rendering"]))
          : (_openBlock(), _createBlock(FullScreenSpinner, { key: 2 }))
      ], 2),
      _createVNode(PaymentSecurityFooter, { paymentOptions: paymentOptions.value }, null, 8, ["paymentOptions"]),
      _createVNode(_unref(Placeholder), {
        name: "jss-footer",
        rendering: _ctx.route
      }, null, 8, ["rendering"])
    ])
  ], 64))
}
}

})